import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import styles from './index.module.scss';
import { setFormData as setStandardFormData } from '../../WarrantyStandardForm/redux/actions';
import { setFormData as setTransferFormData } from '../../WarrantyTransferForm/redux/actions';

const mapStateToProps = state => ({
  formData: state.formData,
});

const AltTextInput = ({
  value,
  htmlAttributes,
  invalidInput,
  icon,
  setStandardFormData,
  setTransferFormData,
  formData,
  fieldKey,
}) => {
  const { placeholder, className, ...otherHtmlAttributes } = htmlAttributes;
  const handleChange = (newValue, keyName) => {
    const { pattern } = htmlAttributes;
    if (formData.formName == 'WarrantyStandard') {
      if (!pattern) {
        setStandardFormData({ [keyName]: newValue });
        return;
      }
      const regexp = new RegExp(`^${pattern}$`);
      if (regexp.test(newValue)) {
        setStandardFormData({ [fieldKey]: newValue.replace(`^${pattern}$`) });
      }
      if (regexp.test(newValue) && htmlAttributes.isphoneinput) {
        setStandardFormData({ [keyName]: newValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') });
      }
    } else {
      if (!pattern) {
        setTransferFormData({ [keyName]: newValue });
        return;
      }

      const regexp = new RegExp(`^${pattern}$`);
      if (regexp.test(newValue)) {
        setTransferFormData({ [fieldKey]: newValue.replace(`^${pattern}$`) });
      }

      if (regexp.test(newValue) && htmlAttributes.isphoneinput) {
        setTransferFormData({ [keyName]: newValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') });
      }
    }
  };
  return (
    <div className={styles.altTextInputWrapper}>
      <input
        type="text"
        onChange={event => handleChange(event.target.value, fieldKey)}
        required
        placeholder={placeholder}
        value={value}
        id={otherHtmlAttributes.id || placeholder}
        {...otherHtmlAttributes}
      />
    </div>
  );
};

AltTextInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  htmlAttributes: PropTypes.object,
  invalidInput: PropTypes.bool,
  icon: PropTypes.node,
};

AltTextInput.defaultProps = {
  htmlAttributes: {},
};

const mapDispatchToProps = dispatch => ({
  setStandardFormData: hash => dispatch(setStandardFormData(hash)),
  setTransferFormData: hash => dispatch(setTransferFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AltTextInput);
